import classNames from 'classnames'
import React from 'react'

export interface SidebarInfoSectionProps {
  children: React.ReactNode
  className?: string
}

export const SidebarInfoSection: React.FC<SidebarInfoSectionProps> = ({
  children,
  className,
}) => {
  return (
    <div className={classNames('my-6 tablet:mt-10', className)}>{children}</div>
  )
}
